/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ word: NonNullable<unknown>, count: NonNullable<unknown> }} Chat_Tool_Bulk_Guard_PromptInputs */



/**
* | output |
* | --- |
* | "Type {word} to approve {count} irreversible actions" |
*
* @param {Chat_Tool_Bulk_Guard_PromptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_guard_prompt = /** @type {((inputs: Chat_Tool_Bulk_Guard_PromptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Guard_PromptInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gib ${i?.word} ein, um ${i?.count} unumkehrbare Aktionen zu genehmigen`)
	return /** @type {LocalizedString} */ (`Type ${i?.word} to approve ${i?.count} irreversible actions`)
});